export const LEGAL_VERSIONS = {
  tos: "2026-05",
  sda: "2026-04",
};
